/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { Geolocation } from '@tmna-ct/ipapps-core-js';
import styles from './styles';

class GeolocationServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geolocationWrapper: new Geolocation(),
      loading: false,
      hide: true,
      coordinates: {},
      speed: null,
      heading: null,
      timestamp: null,
    };
  }

  handlerCurrentPosition() {
    const { geolocationWrapper } = this.state;
    this.setState({ loading: true });
    geolocationWrapper.currentPosition(() => {
      this.setGeoValues();
    });
  }

  handlerWatchPosition() {
    const { geolocationWrapper } = this.state;
    this.setState({ loading: true });
    geolocationWrapper.watchPosition(() => {
      this.setGeoValues();
    });
  }

  handlerClearWatch() {
    const { geolocationWrapper } = this.state;
    geolocationWrapper.clearWatch();
    this.setDefaultValues();
  }

  setDefaultValues() {
    this.setState({
      hide: true,
      loading: false,
      coordinates: {},
      speed: null,
      heading: null,
      timestamp: null,
    });
  }

  setGeoValues() {
    const { geolocationWrapper } = this.state;
    this.setState({
      hide: false,
      loading: false,
      coordinates: geolocationWrapper.coordinates,
      speed: geolocationWrapper.speed,
      heading: geolocationWrapper.heading,
      timestamp: geolocationWrapper.operationTime,
    });
  }
  render() {
    const {
      t,
      classes: { container, mainBody, separation, bodySeparation, disclaimer },
    } = this.props;
    const {
      hide,
      loading,
      coordinates: { latitude, longitude },
      speed,
      heading,
      timestamp,
    } = this.state;

    return (
      <div className={container}>
        <h3 className={separation}>{t('screens.Geolocation.title1')}</h3>
        <div className={mainBody}>
          <div className={bodySeparation}>
            <p>{t('screens.Geolocation.description')}</p>
            <ButtonGroup className={separation} size="small" color="primary">
              <Button onClick={() => this.handlerCurrentPosition()}>
                {t('screens.Geolocation.currentLocation')}
              </Button>
              <Button onClick={() => this.handlerWatchPosition()}>
                {t('screens.Geolocation.watchLocation')}
              </Button>
              <Button onClick={() => this.handlerClearWatch()}>
                {t('screens.Geolocation.claerWatchLocation')}
              </Button>
            </ButtonGroup>
            {loading ? (
              <p className={disclaimer}>
                Loading. . .
              </p>
            ) : null}
            {hide && !loading ? (
              <p className={disclaimer}>
                Click Current Position or Watch Position to see the Geolocation
              </p>
            ) : (
              <React.Fragment>
                <h4 className={separation}>{`Latitude: ${latitude}`}</h4>
                <h4 className={separation}>{`Longitude: ${longitude}`}</h4>
                <h4 className={separation}>{`Heading: ${heading}`}</h4>
                <h4 className={separation}>{`Speed: ${speed}`}</h4>
                <h4 className={separation}>{`Operation timestamp: ${timestamp}`}</h4>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

GeolocationServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(GeolocationServices));
